const config = {
  DOMAIN: "http://localhost/ssj_e-tracking/",
  SITE: "ssj_nont",
  LOGO: "logo/logo.png",
  API_URL_DEV: "http://localhost/ssj_e-tracking/",
  FRONT_URL_DEV: "http://localhost:8080/etracking",
  API_URL_PROD: "https://etracking-nontfda.moph.go.th/",
  FRONT_URL_PROD: "https://etracking-nontfda.moph.go.th",
  ADDR : "ศูนย์บริการผลิตภัณฑ์สุขภาพเบ็ดเสร็จนนทบุรี กลุ่มงานคุ้มครองผู้บริโภคและเภสัชสาธารณสุข สำนักงานสาธารณสุขจังหวัดนนทบุรี เลขที่ 9 ถนนรัตนาธิเบศร์ ต.บางกระสอ อ.เมือง จ.นนทบุรี 11000"
};

export { config };
